import { render, staticRenderFns } from "./AddressBookMultiselect.vue?vue&type=template&id=45a16eab&"
import script from "./AddressBookMultiselect.vue?vue&type=script&lang=js&"
export * from "./AddressBookMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports